import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { MultiPropertyInsuranceFields, PrimaryPropertyInsuranceFields } from './sharedFields/InsuranceFields';

export const UpdateEscrowSettingsRow = z.object({
  loanId: LosId,
  ...PrimaryPropertyInsuranceFields.shape,
  ...MultiPropertyInsuranceFields.shape,
});

export type UpdateEscrowSettingsRow = z.infer<typeof UpdateEscrowSettingsRow>;

export const UPDATE_ESCROW_SETTINGS_ROW_REQUIRED_FIELDS = Object.keys(UpdateEscrowSettingsRow.shape).filter(
  (key) => !UpdateEscrowSettingsRow.shape[key as keyof typeof UpdateEscrowSettingsRow.shape].isOptional(),
) as (keyof UpdateEscrowSettingsRow)[];
